import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericTable from 'componentes/generic/GenericTable.js';
import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const AddressTable = ({ addreses, setIdAddressEdit, setOpenModal }) => {
  const columns = [
    {
      accessorKey: 'calle',
      header: 'Calle',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'noext',
      header: 'No Ext',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'colonia',
      header: 'Colonia',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'codigopostal',
      header: 'CP',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'municipio',
      header: 'Municipio',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'estado',
      header: 'Estado',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'iddireccion',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { iddireccion } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdAddressEdit(iddireccion);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <>
      {addreses && (
        <GenericTable
          data={addreses}
          title="Direcciones"
          columns={columns}
          addAction={() => {
            setIdAddressEdit(0);
            setOpenModal(true);
          }}
        ></GenericTable>
      )}
    </>
  );
};
AddressTable.propTypes = {
  addreses: PropTypes.array.isRequired,
  setIdAddressEdit: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default AddressTable;
